import React from 'react';
export const GlobalAppContext = React.createContext({
    setMenuItemBadge: doNothing,
    setProfileBadge: doNothing,
    setInfoProps: doNothing,
    getTabs: returnEmptyArray,
    setTabs: doNothing,
    openExistingTab: doNothing,
    openTab: doNothing,
    closeTab: doNothing,
    setTabBadge: doNothing,
    setDrawerOpen: doNothing,
    toggleDrawerOpen: doNothing,
});
function returnEmptyArray() {
    return [];
}
function doNothing() {
    // this function intentionally does nothing
}
